import React, { useState } from "react";
import { BsExclamationLg } from "react-icons/bs";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { FaRegSquareCheck } from "react-icons/fa6";
import {
  fetchFutureDeliveries,
  pushFutureDelivery,
} from "../../../redux/slices/futureDeliverySlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const ModalFutureDelivery = ({ orderId, name, delivery_date }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("delivery_date", delivery_date);

      const res = await dispatch(
        pushFutureDelivery({
          id: orderId,
          formData,
        }),
      );

      if (pushFutureDelivery.fulfilled.match(res)) {
        // ✅ message from backend
        toast.success(res.payload?.message || "Request successful");

        setShowModal(false);
        dispatch(fetchFutureDeliveries());
      } else {
        // ✅ error message from backend
        toast.error(
          res.payload?.message ||
            res.payload?.error ||
            "Failed to push delivery",
        );
      }
    } catch (err) {
      console.error(err);

      // fallback error
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Trigger Button */}
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="flex gap-2 items-center bg-white border-2 p-2 rounded-lg"
      >
        <FaRegSquareCheck className="text-green-600 text-lg hover:scale-110 transition" />
        <p className="text-sm font-semibold">Push Order</p>
      </button>

      {/* Modal */}
      {showModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="relative w-full max-w-md mx-auto">
              <div className="bg-white rounded-xl shadow-lg p-6 relative">
                {/* Close */}
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
                >
                  <FaTimes />
                </button>

                {/* Icon */}
                <div className="flex justify-center mb-3">
                  <BsExclamationLg className="text-yellow-500 text-4xl" />
                </div>

                {/* Title */}
                <h2 className="text-xl font-semibold text-center text-gray-800">
                  Push Future Deliveries
                </h2>

                {/* Message */}
                <p className="text-center text-gray-500 mt-2">
                  Are you sure you want to push future deliveries for this
                  order?
                </p>

                {/* Info */}
                <div className="mt-4 text-center">
                  <p className="text-sm text-gray-400">Order ID</p>
                  <p className="font-bold text-gray-800">{orderId}</p>

                  {name && (
                    <>
                      <p className="text-sm text-gray-400 mt-2">Customer</p>
                      <p className="font-medium text-gray-700">{name}</p>
                    </>
                  )}

                  {/* Optional: show delivery date */}
                  {/* {delivery_date && (
                    <>
                      <p className="text-sm text-gray-400 mt-2">
                        Delivery Date
                      </p>
                      <p className="font-medium text-gray-700">
                        {delivery_date}
                      </p>
                    </>n 
                  )} */}
                </div>

                {/* Actions */}
                <div className="flex justify-center gap-4 mt-6">
                  <button
                    onClick={() => setShowModal(false)}
                    disabled={loading}
                    className="px-4 py-2 rounded-md bg-gray-100 text-gray-600 font-medium"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleConfirm}
                    disabled={loading}
                    className="px-4 py-2 rounded-md bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Processing...
                      </>
                    ) : (
                      "Confirm"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Overlay */}
          <div className="fixed inset-0 bg-black opacity-30 z-40"></div>
        </>
      )}
    </>
  );
};

export default ModalFutureDelivery;
